import { gql } from "@apollo/client"

export const GET_ALMACEN = gql`
    query Almacenes($hotel_id: ID) {
        almacenes(almacen_id: [], hotel_id: $hotel_id) {
            almacen_id
            nombre
        }
    }
`
